import { Routes } from '@angular/router';
import { authGuard } from '../guard/auth.guard';

export const ageyRoutes: Routes = [
    {
        path: 'agey/proposals-list',
        loadComponent: () => import('../agey/proposals-list.component').then((m) => m.ProposalsListComponent)
    },
    {
        path: 'agey/proposals-details',
        loadComponent: () =>
            import('../agey/proposals-details/proposals-details.component').then((m) => m.PraposalsDetailsComponent)
    },
    {
        path: 'agey/proposal-create-form',
        loadComponent: () =>
            import('../agey/proposal-create-form/proposal-create-form.component').then(
                (m) => m.ProposalCreateFormComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'agey/proposals',
        loadComponent: () => import('../agey/proposals-list.component').then((m) => m.ProposalsListComponent),
        canActivate: [authGuard]
    },
    {
        path: 'agey/vehicle-details',
        loadComponent: () =>
            import('../agey/proposals-details/vehicles-list/vehicle-details/vehicle-details.component').then(
                (m) => m.VehicleDetailsComponent
            ),
        canActivate: [authGuard]
    }
];

export const ageyMobileRoutes: Routes = [
    {
        path: 'mobile/agey/home',
        loadComponent: () => import('../mobile/pages/agey/home/home.component').then((m) => m.HomeComponent),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/agey/proposals-details',
        loadComponent: () =>
            import('../mobile/pages/agey/proposal-details/proposal-details.component').then(
                (m) => m.ProposalDetailsComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/agey/proposals',
        loadComponent: () =>
            import('../mobile/pages/agey/proposal-list/proposal-list.component').then((m) => m.ProposalListComponent),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/agey/vehicles',
        loadComponent: () =>
            import('../mobile/pages/agey/vehicle-list/vehicle-list.component').then((m) => m.VehicleListComponent),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/agey/vehicle-details',
        loadComponent: () =>
            import('../mobile/pages/agey/vehicle-details/vehicle-details.component').then(
                (m) => m.VehicleDetailsComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/agey/repayment',
        loadComponent: () =>
            import('../mobile/pages/agey/repayment/repayment.component').then((m) => m.RepaymentComponent),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/agey/expenditure',
        loadComponent: () =>
            import('../mobile/pages/agey/expenditure/expenditure.component').then((m) => m.ExpenditureComponent),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/agey/add-agey-repayment',
        loadComponent: () =>
            import('../mobile/pages/agey/add-agey-repayment/add-agey-repayment.component').then(
                (m) => m.AddAgeyRepaymentComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/agey/agey-new-vehicle-form',
        loadComponent: () =>
            import('../mobile/pages/agey/agey-new-vehicle-form/agey-new-vehicle-form.component').then(
                (m) => m.AgeyNewVehicleFormComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/agey/vehicle-summary',
        loadComponent: () =>
            import('../mobile/pages/agey/agey-new-vehicle-form/screen-features/agey-vehicle-summary/agey-vehicle-summary.component').then(
                (m) => m.AgeyVehicleSummaryComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/agey/monthly-income',
        loadComponent: () =>
            import('../mobile/pages/agey/monthly-income/monthly-income.component').then(
                (m) => m.MonthlyIncomeComponent
            ),
        canActivate: [authGuard]
    }
];
